import { useState, useEffect } from "react";
import { RegisterStatus, CONNECT_STATUS, useSIPProvider } from "@pr0tel/react-sipjs";
import { SessionState } from "sip.js";
import "./WebCall.css";
import {
  Button,
  TextField,
  Typography,
  Box,
  Paper,
  CircularProgress,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { green, yellow } from "@mui/material/colors";
import TranslatedText from "../../../utils/Translate";
import axios from "axios";
import { logOut } from "../../../utils/logOut";
import { useAppDispatch } from "../../../store";
import { useSelector } from "react-redux";
import { getClientLangByCode } from "../../../utils/LanguageList";
import { useSnackbar } from "../../../utils/SnackbarContext";

export const CallCenter = ({webRtcCredentials}:any) => {
  const {
    connectAndRegister,
    sessionManager,
    registerStatus,
    connectStatus,
  } = useSIPProvider();
  const [isCalling, setIsCalling] = useState<boolean>(false);
  const [callInProcess, setCallInProcess] = useState<boolean>(false);
  const [currentSession, setCurrentSession] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [activeBars, setActiveBars] = useState([false, false, false, false, false]);
  const [conversationtemplates, setConversationtemplates] = useState([])
  const [connectCode, setConnectCode] = useState(Array.from({ length: 6 }, () => Math.floor(Math.random() * 10)).join(''))
  const [callData, setCallData] = useState({
    conversationtemplate: localStorage.getItem('ct_webrtc') ? localStorage.getItem('ct_webrtc') : ''
  })

  const { showSnackbar } = useSnackbar();

  const dispatch = useAppDispatch()

  const contactData = useSelector(
          (state: any) => state.webcall
      )

  const language = useSelector(
          (state: any) => state.auth.authData.language
      );
  
    console.log(contactData);


    async function createCall(data: any = {}) {
      try {
          const response = await axios.post(`https://cardgarantsales.com/restapi/webrtc`, {
              ...data
          }, {
              headers: {
                  'Content-Type': 'application/json',
                  "Authorization": "Bearer " + localStorage.getItem('access_token')
              },
          })

      } catch (error: any) {
          console.log(error);
          if (error.code === "ERR_NETWORK") {
              showSnackbar('ERROR NETWORK', 'error')
          }
      }
  }
    


  async function getConversationtemplates(params: object = {}) {
    try {
      const response = await axios.get(`https://cardgarantsales.com/restapi/conversationtemplate`, {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": "Bearer " + localStorage.getItem('access_token')
        }, params: params
      })
      console.log(response.data);
      setConversationtemplates(response.data)
    } catch (error: any) {
      console.log(error);
      if (error.message === "Request failed with status code 401") {
        logOut(dispatch)
      }
      else if (error.code === "ERR_NETWORK") {
        showSnackbar('ERROR NETWORK', 'error')
      }
    }
  }



  useEffect(() => {
    getConversationtemplates();
  }, []);


  useEffect(() => {
      connectAndRegister({
        username: webRtcCredentials.username,
        password: webRtcCredentials.password,
        coturn: webRtcCredentials.coturn,
        coturnusername: webRtcCredentials.coturnusername,
        coturnpassword: webRtcCredentials.coturnpassword,
        displayName: Object.keys(contactData).length != 0 ? contactData.clientid : connectCode
      });
  }, [connectAndRegister]);





  const handleCall = async (e: any) => {
    e.preventDefault();

    setError(null); // Очистка ошибки перед новым звонком

    // Завершаем текущую сессию перед новым звонком, если она существует
    if (currentSession) {
      currentSession.bye();
      setCurrentSession(null);
      setIsCalling(false);
      setCallInProcess(false)
    }

    try {
      if (Object.keys(contactData).length != 0) {
        await createCall({...contactData, partnerbank: localStorage.getItem('partner') && localStorage.getItem('partner') != "null" ? localStorage.getItem('partner') : '', conversationtemplate: callData.conversationtemplate == '' ? contactData.conversationtemplate : callData.conversationtemplate, mobilephone: webRtcCredentials.username, customerlead: contactData.id, clientid: contactData.clientid});
      }
      else {
        await createCall({...callData, partnerbank: localStorage.getItem('partner') && localStorage.getItem('partner') != "null" ? localStorage.getItem('partner') : '', mobilephone: webRtcCredentials.username, language_client: getClientLangByCode(language), clientid: connectCode});
      }
      setIsCalling(true);
      const session = await sessionManager?.call(`sip:${webRtcCredentials.did}@${webRtcCredentials.domain}`, {});

      session?.stateChange.addListener(state => {
        switch (state) {
          case SessionState.Establishing:
            console.log('Establishing');

            break;
          case SessionState.Established:
            console.log('Established');
            setCallInProcess(true)
            break;
          case SessionState.Terminated:
            console.log('Terminated');
            setCurrentSession(null);
            setIsCalling(false);
            setCallInProcess(false)
            break;
        }
      });

      setCurrentSession(session); // Сохраняем текущую сессию
    } catch (err) {
      console.error("Error attempting to connect.", err);
      setError("Error attempting to connect.")
      setIsCalling(false);
      setCallInProcess(false)
    }
  };

  const handleHangUp = (e: any) => {
    e.preventDefault();
    if (currentSession) {
      currentSession.bye(); // Завершаем текущую сессию звонка
      setCurrentSession(null);
      setIsCalling(false);
      setCallInProcess(false)
    }
  };

  return (
    <Box display="flex" justifyContent="center" >
      <Paper
        elevation={0}
        sx={{ p: 3, minWidth: 400, maxWidth: 500, borderRadius: 2 }}
      >
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6" gutterBottom>
            <TranslatedText text={"Connect with robot"} />
          </Typography>
          <Box sx={{ paddingBottom: '5px' }}>
            {(registerStatus === RegisterStatus.REGISTERED && connectStatus === CONNECT_STATUS.CONNECTED) ?
              <Box className="breath-animation" sx={{
                borderRadius: 90, width: 10, height: 10,
                background: green[500]

              }} />
              : <CircularProgress
                size={10}
                style={{
                  color: yellow[700],
                }}
              />
            }
          </Box>
        </Box>

        <div className="audio-visualization" id="remoteVisualization">
          {activeBars.map((isActive, index) => (
            <div
              key={index}
              className={`bar ${callInProcess ? 'active' : ''}`}
              style={{ animationDelay: callInProcess ? `${index * 0.2}s` : '1s' }}
            ></div>
          ))}
        </div>


        {/* <Box mb={4}>
          <Typography variant="body1" color="textSecondary" gutterBottom>
            Статус подключения
          </Typography>
          <Box display="flex" alignItems="center" gap={1.5}>
            {connectStatus === CONNECT_STATUS.CONNECTED ? 
            <Box sx={{
              borderRadius: 90, width: 10, height: 10,
              background: green[500]

            }} />
            : <CircularProgress
              size={10}
              style={{
                color: yellow[700],
              }}
            />
           }
            <Typography variant="body2" color="textSecondary">
              Connect Status: {connectStatus}
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" gap={1.5}>
           {registerStatus === RegisterStatus.REGISTERED ? 
            <Box sx={{
              borderRadius: 90, width: 10, height: 10,
              background: green[500]

            }} />
            : <CircularProgress
              size={10}
              style={{
                color: yellow[700],
              }}
            />
           }
            <Typography variant="body2" color="textSecondary">
              Register Status: {registerStatus}
            </Typography>
          </Box>
        </Box> */}

        <form onSubmit={handleCall}>
          {/* <Typography variant="body1" color="textSecondary" gutterBottom>
            Введите номер для звонка:
          </Typography> */}
          {/* <TextField
            fullWidth
            size="small"
            label={<TranslatedText text={"Enter number to call "} />}
            value={callTo}
            onChange={(e) => setCallTo(e.target.value)}
            sx={{
              mt: 2,
              mb: 3,
              borderRadius: 2,
              backgroundColor: "#f4f4f9",
            }}
          /> */}
          <FormControl sx={{ width: '100%', mt: 2}}>
            <InputLabel size="small" id="simple-select-label"><TranslatedText text={'Conversation template'} /></InputLabel>
            <Select
             sx={{
              width: '100%',
              mb: 2,
              borderRadius: 1,
              backgroundColor: "#f4f4f9",
            }} labelId="simple-select-label" onChange={(e) => {setCallData({ ...callData, conversationtemplate: e.target.value !== '' ? e.target.value : '' });  localStorage.setItem('ct_webrtc', e.target.value);}} value={callData.conversationtemplate || ''} variant="outlined" size="small" label={<TranslatedText text={'Conversation template'} />} >
              {
                conversationtemplates.map((el: any) => {
                  //make conversationtemplate list item
                  return (
                    <MenuItem key={el.id} value={el.id}>{el.conversationtemplatecode}</MenuItem>
                  )
                })
              }
            </Select>
          </FormControl>
          {/* Сообщение об ошибке */}
          {error && <Alert sx={{ mb: 2 }} severity="error"><TranslatedText text={error} /></Alert>}
          {Object.keys(contactData).length != 0 && <Typography sx={{mb:2, opacity: 0.7}} textAlign={'center'} variant="body2"><TranslatedText text={"Using data from contact"} />: <span style={{fontWeight: 700}}>{contactData.clientid}</span></Typography>}

          <Box display="flex" justifyContent="center" gap={2}>
            <Button
              onClick={handleCall}
              variant="contained"
              color="primary"
              disabled={isCalling}
            >
              {(!callInProcess && isCalling) ? <Typography sx={{textAlign: 'center'}}><TranslatedText text={'Connecting'} />...</Typography> : <TranslatedText text={"Call"} />}
            </Button>
            <Button
              onClick={handleHangUp}
              variant="contained"
              color="primary"
              disabled={!callInProcess}
            >
              <TranslatedText text={"End call"} />
            </Button>
          </Box>
        </form>
      </Paper>
    </Box>
  );
};
